import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import CarModelItem from "./CardList";
import { fetchCampaignsWithContent } from "@/app/lib/getData";

interface AccordionProps {
  contents?: string[];
  title_contents?: string[];
}

export const Accordion: React.FC<AccordionProps> = ({
  contents: initialContents = [],
  title_contents: initialTitleContents = [],
}) => {
  const pathname = usePathname();
  const [contents, setContents] = useState<string[]>(initialContents);
  const [titleContents, setTitleContents] = useState<string[]>(initialTitleContents);
  const [filteredIndexes, setFilteredIndexes] = useState<number[]>([]);

  useEffect(() => {
    const loadCampaigns = async () => {
      try {
        const { contents: campaignContents, title_contents: campaignTitleContents, calls } = await fetchCampaignsWithContent();
        
        // Filtra os índices baseado no pathname atual
        const indexes = calls.reduce<number[]>((acc, call, index) => {
          const paths = call.split(",").map(path => path.trim());
          if (paths.includes(pathname || "/")) {
            acc.push(index);
          }
          return acc;
        }, []);

        setContents(campaignContents);
        setTitleContents(campaignTitleContents);
        setFilteredIndexes(indexes);
      } catch (error) {
        console.error("Erro ao carregar campanhas:", error);
      }
    };

    loadCampaigns();
  }, [pathname]);

  if (!contents?.length || !titleContents?.length || !filteredIndexes.length) {
    return null;
  }

  return (
    <section className="flex flex-col px-6 pt-4 pb-8 text-xs bg-white text-zinc-500 max-md:px-5">
      {filteredIndexes.map((index, arrayIndex) => {
        const content = contents[index];
        const titleContent = titleContents[index];

        if (!content || !titleContent) return null;

        return (
          <React.Fragment key={index}>
            <CarModelItem
              name={titleContent}
              description={content}
            />
            {arrayIndex < filteredIndexes.length - 1 && (
              <div className="shrink-0 mt-2 h-0.5 bg-zinc-300 max-md:max-w-full" />
            )}
          </React.Fragment>
        );
      })}
    </section>
  );
};

export default Accordion;
